import gql from 'graphql-tag'
import client from '@stores/apollo'
import { CatalogEmployeeFragment } from '@api/fragments'
import { KeyValueFilter, ValueFilter } from './types'
import { ICatalogEmployeeConnectionWithTotal } from '@api/types'

interface IPayload {
  data: {
    viewer: {
      company: {
        employees: ICatalogEmployeeConnectionWithTotal
      }
    }
  }
}

export interface IVariables {
  assignmentPlanId?: string
  after?: number
  first: number
  ValueFilter: ValueFilter[]
  keyValueFilters: KeyValueFilter[]
  filters: KeyValueFilter[]
}

export default function catalog(
  variables: IVariables
): Promise<ICatalogEmployeeConnectionWithTotal> {
  return client.gql.query({ query, variables }).then(
    ({
      data: {
        viewer: {
          company: { employees },
        },
      },
    }: IPayload) => employees
  )
}

export const query = gql`
  query EmployeeCatalog(
    $assignmentPlanId: ID
    $first: Int
    $after: String
    $keyValueFilters: [EmployeeKeyValueFiltersInput]
    $ValueFilter: [FilterEnum]
    $filters: [EmployeeFiltersInput]
  ) {
    viewer {
      company {
        employees(
          first: $first
          after: $after
          sortBy: name
          order: ASC
          keyValueFilters: $keyValueFilters
          ValueFilter: $ValueFilter
          filters: $filters
        ) {
          counters {
            total
          }
          pageInfo {
            endCursor
            hasNextPage
          }
          edges {
            node {
              ...Employee
            }
          }
        }
      }
    }
  }
  ${CatalogEmployeeFragment}
`
